
/**
 * Setup the MutationObserver to let us know when to draw our UI
 */
export function setupObserver(selectorArray, callback) {
  console.log('Setting up observer to determine when Remote Access frame can be embedded');
  let isDrawing = false;

  /**
   * Callback function for mutation event that determines if the elements we need have been
   * added to the DOM, in which case we load the UI
   */
  let mutationCallback = (mutations, observer) => {
    mutations.forEach(function (mutation) {
      if (!isDrawing && mutation.type === 'childList') {
        checkForSelectors(observer);
      }
    });
  };

  /**
   * Callback function for mutation event for IE9/10 which do not support MutationObservers
   * They also don't support Promises, so this only exists to show a nicer error screen.
   */
  // let mutationEventCallback = (evt) => {
  //   for (let i = 0; i < selectorArray.length; i++) {
  //     const selector = selectorArray[i];
  //     const formExists = document.querySelector(selector);
  //     if (formExists && !isDrawing) {
  //       isDrawing = true;
  //       console.log('Removing event listener.');
  //       document.removeEventListener('DOMNodeInserted', mutationEventCallback);
  //       callback(selector);
  //     }
  //   }
  // }

  let checkForSelectors = (observer) => {
    for (let i = 0; i < selectorArray.length; i++) {
      const selector = selectorArray[i];
      const formExists = document.querySelector(selector);
      if (formExists && !isDrawing) {
        isDrawing = true;
        console.log('Tearing down observer.');
        if (observer) {
          observer.disconnect();
        }
        callback(selector);
        return true;
      }
    }
  };

  try {
    if (!checkForSelectors() ) {
      let observer = new MutationObserver(function (mutations) {
        mutationCallback(mutations, observer);
      });
      let config = { childList: true, subtree: true, };
      observer.observe(document, config);
    }
  }
  catch (Ex) {
    console.log('Error: This browser does not support MutationObservers');
    // console.log(Ex);
    // Browser (probably IE9-10) does not support MutationObserver - falling back to MutationEvent method
    // try {
    //   document.selectorArray = selectorArray;
    //   document.addEventListener('DOMNodeInserted', mutationEventCallback, false);
    // } catch (ex) {
    //   console.log('Unsupported browser version');
    // }
  }
}

